import React from 'react';
import styles from './InputComponents.module.css';

const ConditionWithDurationInput = ({ question, value, error, onChange, isSubmitted }) => {
    const conditionValue = value || { hasCondition: '', duration: '' };

    const handleConditionChange = (hasCondition) => {
        onChange({ ...conditionValue, hasCondition });
    };

    const handleDurationChange = (duration) => {
        onChange({ ...conditionValue, duration });
    };

    return (
        <div className={styles.questionWrapper}>
            <label className={styles.questionLabel}>
                {question.text}
                {question.required && <span className={styles.required}>*</span>}
            </label>
            {question.annotation && (
                <span className={styles.annotation}>{question.annotation}</span>
            )}

            <div className={styles.conditionWithDurationContainer}>
                <div className={styles.conditionRadioGroup}>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            value="YES"
                            checked={conditionValue.hasCondition === 'YES'}
                            onChange={(e) => handleConditionChange(e.target.value)}
                            disabled={isSubmitted}
                            className={styles.radioInput}
                        />
                        <span>YES</span>
                    </label>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            value="NO"
                            checked={conditionValue.hasCondition === 'NO'}
                            onChange={(e) => handleConditionChange(e.target.value)}
                            disabled={isSubmitted}
                            className={styles.radioInput}
                        />
                        <span>NO</span>
                    </label>
                </div>

                {conditionValue.hasCondition === 'YES' && (
                    <div className={styles.durationInput}>
                        <label className={styles.durationLabel}>Duration:</label>
                        <input
                            type="text"
                            value={conditionValue.duration || ''}
                            onChange={(e) => handleDurationChange(e.target.value)}
                            disabled={isSubmitted}
                            placeholder="e.g., 2 years, 6 months"
                            className={`${styles.input} ${styles.durationField}`}
                        />
                    </div>
                )}
            </div>

            {error && <span className={styles.errorText}>{error}</span>}
        </div>
    );
};

export default ConditionWithDurationInput;